import { gql } from '@apollo/client'

export default gql`
  query UseTrackIdentity {
    session {
      id
    }
  }
`
